export default __webpack_public_path__ + "8fc116fbb1cf82ec57db5cac028b292a.png";